import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const FulfillmentProviderOUMComponent = ({ selectFulfillmentProvider, onInnerFormChange, organizationUnits }: any) => (
  <>
    <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
            label="Limited To OrganizationUnit"
            labelField="Name"
            list={organizationUnits}
            onValueChange={(newValue: any) => {
              const valueData: any = newValue.map((option: any) => option?.value || '')
              onInnerFormChange(
                valueData,
                'LimitedToOrganizationMappings.LimitedToOrganizationUnitIds',
                selectFulfillmentProvider?.LimitedToOrganizationUnitMappings
              );
            }}
            type="multiselect"
            valueField="Id"
            value={selectFulfillmentProvider?.LimitedToOrganizationMappings?.LimitedToOrganizationUnitIds}
          />
        </div>
      }
      expandedPanel="OUMInfo"
      headerTitle="OUM Info"
    />
  </>
)
export default FulfillmentProviderOUMComponent;
